<template>
<div class='bodyer service-list'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <img src='/static/image/icon/title-icon-service.png' class='icon'>服务记录
                </div>
            </div>
        </div>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='yi-title'>服务记录</div>
            <table class='yi-table list'>
                <tr><th>单号</th>
                    <th>问题类型</th>
                    <th>受理时间</th>
                    <th>回复内容</th>
                    <th>状态</th>
                    <th>操作</th>
                </tr>
                <tr v-for='item in list'>
                    <td>{{item.id}}</td>
                    <td>{{item.type_text}}</td>
                    <td>{{item.dealt_at || '未受理'}}</td>
                    <td>{{item.reply_sim}}</td>
                    <td>{{item.status_text}}</td>
                    <td>
                        <a @click='showReply(item.reply)' style='cursor: pointer' 
                            v-if='item.reply'>查看</a>
                        <a v-if='!item.reply'>待处理</a>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class='modal modal-relay fade'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    回复内容
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    {{reply}}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Request from '@/common/Request';
import Common from '@/common/Common';
import Notify from '@/common/Notify';
export default {
    data : function(){
        return {
            'list' : [],
            'reply' : '',
        }
    },
    props : ['user'],
    methods : {
        //列表获取
        get_list : function(){
            var url = Request.createApi('/app/question/list?page=1&limit=100');
            Request.get(url, res => {
                this.list = res.list
                console.log(res.list)
            })
        },

        //展示回复
        showReply : function(reply){
            this.reply = reply
            $('.modal-relay').modal('show')
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        if(!this.user){
            Common.toUrl('/login');
            return false
        }
        this.get_list()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/service/Log.vue